export default __webpack_public_path__ + "static/media/V210_D_BD.9c96fa0f.pdf";